import React from 'react';

interface DuoToggleOption {
  label: string;
  value: string;
}

interface DuoToggleProps {
  options: [DuoToggleOption, DuoToggleOption];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const DuoToggle: React.FC<DuoToggleProps> = ({ options, value, onChange, className = '' }) => {
  const activeIndex = options.findIndex(opt => opt.value === value);

  return (
    <div
      className={`relative inline-flex items-center p-1 rounded-full border-2 border-primary dark:border-primary bg-white dark:bg-gray-900 ${className}`}
    >
      {/* Sliding background indicator */}
      <div
        className="absolute h-[calc(100%-8px)] rounded-full bg-primary transition-all duration-300 ease-in-out"
        style={{
          width: `calc(50% - 4px)`,
          left: activeIndex === 0 ? '4px' : 'calc(50%)',
        }}
      />

      {/* Option buttons */}
      {options.map((option, index) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`relative z-10 flex-1 px-6 py-2 text-sm font-medium rounded-full transition-colors duration-300 text-center
            ${value === option.value
              ? 'text-white'
              : 'text-primary hover:text-primary/80'
            }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default DuoToggle;
